<template>
    <div class="kline_chart">
    <el-tabs v-model="activeKlineTab" @tab-click="chartChange">
  
      <el-tab-pane label="分时" name="timeshare"><div id="timeshare" style="width: auto; height: 443px;"></div>
      </el-tab-pane>
  
      <el-tab-pane label="日K" name="dayK"><div id="dayK" style="height:443px;"/>
      </el-tab-pane>
  
      <el-tab-pane label="周K" name="weekK"><div id="weekK" style="height:443px;"/>
      </el-tab-pane>
  
      <el-tab-pane label="月K" name="monthK"><div id="monthK" style="height:443px;"/>
      </el-tab-pane>
          
      <el-tab-pane label="1m" name="m1"><div id="m1" style="height:443px;"/>
      </el-tab-pane>
          
      <el-tab-pane label="5m" name="m5"><div id="m5" style="height:443px;"/>
      </el-tab-pane>
          
      <el-tab-pane label="15m" name="m15"><div id="m15" style="height:443px;"/>
      </el-tab-pane>
          
      <el-tab-pane label="30m" name="m30"><div id="m30" style="height:443px;"/>
      </el-tab-pane>
         
      <el-tab-pane label="1小时" name="m60"><div id="m60" style="height:443px;"/>
      </el-tab-pane>
    </el-tabs>
  </div>
  </template>
  

<script>
import { init, dispose } from 'klinecharts';
import $ from "jquery";
import * as echarts from "echarts";
import { getStyle } from "./../Kline/style.js"
const styles = getStyle()


export default{
    data() {
        return {
          activeKlineTab: "timeshare",
            timerRef: null,
            timerRefTop: null,
            refreshInterval: 2000,
           selectedShare: this.$route.query.symbol || '',
            daychart: '',
            topData: {
        name: "--",
      },
        }
    },
    computed: {    
    },
    methods: {
        loadData() {
      switch (this.activeKlineTab) {
        case "timeshare":
          this.loadTimeShareData(this.selectedShare);
          break;
        case "dayK":
          this.loadklineData(this.selectedShare, "day", "dayK");
          break;
        case "weekK":
          this.loadklineData(this.selectedShare, "week", "weekK");
          break;
        case "monthK":
          this.loadklineData(this.selectedShare, "month", "monthK");
          break;
        case "m1":
          this.loadklineData(this.selectedShare, "m1", "m1");
          break;
        case "m5":
          this.loadklineData(this.selectedShare, "m5", "m5");
          break;
        case "m15":
          this.loadklineData(this.selectedShare, "m15", "m15");
          break;
        case "m30":
          this.loadklineData(this.selectedShare, "m30", "m30");
          break;
        case "m60":
          this.loadklineData(this.selectedShare, "m60", "m60");
          break;
        default:
          break;
      }
    },
    loadklineData(code, type, chartId) {
      let url,
        that = this;
      if (type === "m1" || type === "m5" || type === "m15" || type === "m30" || type === "m60") {
        url = "https://ifzq.gtimg.cn/appstock/app/kline/mkline?param=";
        $.get(
          url + code + "," + type + ",,800&_var=" + type+"_today",
        function (res) {
          const jsonString = res.replace(type+"_today=", ""); 
          res = JSON.parse(jsonString);
          let data = res.data[code][type];
          
          that.loadNewKline(data, chartId);
        }
      );
      } else if(type === "day" || type === "week"){
        url = "https://web.ifzq.gtimg.cn/appstock/app/fqkline/get?_var=kline_";
        $.get(
        url + type + "&param="+code+","+type+",,,1000,",
        function (res) {
          const jsonString = res.replace("kline_"+type+"=", ""); 
          res = JSON.parse(jsonString);
          let data = res.data[code][type];
          that.loadNewKline(data, chartId);
        }
      );
      }else if(type === "month"){
        url = "https://web.ifzq.gtimg.cn/appstock/app/fqkline/get?_var=kline_";
        $.get(
        url + type + "&param="+code+","+type+",,,400,",
        function (res) {
          const jsonString = res.replace("kline_"+type+"=", ""); 
          res = JSON.parse(jsonString);
          let data = res.data[code][type];
          that.loadNewKline(data, chartId);
        }
      );
      }
    },
    loadNewKline(data, chartId){
      if((this.daychart == '' || this.daychart == null) && chartId == 'dayK'){
        this.daychart = init(document.getElementById(chartId),{ locale: 'en-US' });
        this.daychart.createIndicator('VOL');
        this.daychart.setStyles(styles);
    }

      if((this.weekchart == '' || this.weekchart == null) && chartId == 'weekK'){
        this.weekchart = init(document.getElementById(chartId),{ locale: 'en-US' });
        this.weekchart.createIndicator('VOL');
        this.weekchart.setStyles(styles);
    }

      if((this.monthchart == '' || this.monthchart == null) && chartId == 'monthK'){
        this.monthchart = init(document.getElementById(chartId),{ locale: 'en-US' });
        this.monthchart.createIndicator('VOL');
        this.monthchart.setStyles(styles);
    }

      if((this.minute1chart == '' || this.minute1chart == null) && chartId == 'm1'){
        this.minute1chart = init(document.getElementById(chartId),{ locale: 'en-US' });
        this.minute1chart.createIndicator('VOL');
        this.minute1chart.setStyles(styles);
    }
      if((this.minute5chart == '' || this.minute5chart == null) && chartId == 'm5'){
        this.minute5chart = init(document.getElementById(chartId),{ locale: 'en-US' });
        this.minute5chart.createIndicator('VOL');
        this.minute5chart.setStyles(styles);
    }
      if((this.minute15chart == '' || this.minute15chart == null) && chartId == 'm15'){
        this.minute15chart = init(document.getElementById(chartId),{ locale: 'en-US' });
        this.minute15chart.createIndicator('VOL');
        this.minute15chart.setStyles(styles);
    }
      if((this.minute30chart == '' || this.minute30chart == null) && chartId == 'm30'){
        this.minute30chart = init(document.getElementById(chartId),{ locale: 'en-US' });
        this.minute30chart.createIndicator('VOL');
        this.minute30chart.setStyles(styles);
    }
      if((this.minute60chart == '' || this.minute60chart == null) && chartId == 'm60'){
        this.minute60chart = init(document.getElementById(chartId),{ locale: 'en-US' });
        this.minute60chart.createIndicator('VOL');
        this.minute60chart.setStyles(styles);
    }
      data = splitData(data);
      if(chartId == 'dayK'){
        this.daychart.applyNewData(data.categoryData)
      }else if(chartId == 'weekK'){
        this.weekchart.applyNewData(data.categoryData)
      }else if(chartId == 'monthK'){
        this.monthchart.applyNewData(data.categoryData)
      }else if(chartId == 'm1'){
        this.minute1chart.applyNewData(data.categoryData)
      }else if(chartId == 'm5'){
        this.minute5chart.applyNewData(data.categoryData)
      }else if(chartId == 'm15'){
        this.minute15chart.applyNewData(data.categoryData)
      }else if(chartId == 'm30'){
        this.minute30chart.applyNewData(data.categoryData)
      }else if(chartId == 'm60'){
        this.minute60chart.applyNewData(data.categoryData)
      }
      function splitData(rawData) {
        var categoryData = [];
        for (var i = 0; i < rawData.length; i++) {
          var newTimeStamp = '';
          if(chartId == 'm1' || chartId == 'm5' || chartId == 'm15' || chartId == 'm30' || chartId == 'm60'){
            // Handle full timestamp in "YYYYMMDDHHMM" format
            var mtimestamp = rawData[i].splice(0, 1)[0];
            const year = mtimestamp.slice(0, 4);
            const month = mtimestamp.slice(4, 6);
            const day = mtimestamp.slice(6, 8);
            const hour = mtimestamp.slice(8, 10);
            const minute = mtimestamp.slice(10, 12);

            newTimeStamp = new Date(`${year}-${month}-${day}T${hour}:${minute}:00`).getTime();
          }
          else{
            newTimeStamp = new Date(rawData[i].splice(0, 1)[0]).getTime();
          }
          categoryData.push({
            timestamp: newTimeStamp,
            open: Number(rawData[i].splice(0, 1)[0]),
            close: Number(rawData[i].splice(0, 1)[0]),
            high: Number(rawData[i].splice(0, 1)[0]),
            low: Number(rawData[i].splice(0, 1)[0]),
            volume: Number(rawData[i].splice(0, 1)[0])
          });
        }
        return {
          categoryData: categoryData,
        };
      }
    },
    loadTopData() {
      let that = this;
      let url = "https://sqt.gtimg.cn/utf8/q="+that.selectedShare;
      $.ajax({
        url: url,
        type: "GET",
        dataType: "script",
        cache: true,
        success: function () {
          var i, elements;
          // var array = [];
          var topDataNw = {};

          elements = eval("v_" + that.selectedShare).split("~");

          topDataNw.name = elements[1]; // 股票名称
          topDataNw.code = elements[2]; // 不带字幕的股票代码，603045
          topDataNw.price = elements[3]; // 当前价格
          topDataNw.yesterdayClosePrice = elements[4]; // 昨收
          topDataNw.todayOpenPrice = elements[5]; // 今开

          topDataNw.buy1Price = elements[9]; // 买1价格
          topDataNw.buy1Num = elements[10]; // 买1数量（手）
          topDataNw.buy2Price = elements[11]; // 买2价格
          topDataNw.buy2Num = elements[12]; // 买2数量（手）
          topDataNw.buy3Price = elements[13]; // 买3价格
          topDataNw.buy3Num = elements[14]; // 买3数量（手）
          topDataNw.buy4Price = elements[15]; // 买4价格
          topDataNw.buy4Num = elements[16]; // 买4数量（手）
          topDataNw.buy5Price = elements[17]; // 买5价格
          topDataNw.buy5Num = elements[18]; // 买5数量（手）

          topDataNw.sell1Price = elements[19]; // 卖1价格
          topDataNw.sell1Num = elements[20]; // 卖1数量（手）
          topDataNw.sell2Price = elements[21]; // 卖2价格
          topDataNw.sell2Num = elements[22]; // 卖2数量（手）
          topDataNw.sell3Price = elements[23]; // 卖3价格
          topDataNw.sell3Num = elements[24]; // 卖3数量（手）
          topDataNw.sell4Price = elements[25]; // 卖4价格
          topDataNw.sell4Num = elements[26]; // 卖4数量（手）
          topDataNw.sell5Price = elements[27]; // 卖5价格
          topDataNw.sell5Num = elements[28]; // 卖5数量（手）

          topDataNw.increase = elements[31]; // 涨、跌额
          topDataNw.increasePercent = elements[32]; // 涨、跌幅
          topDataNw.maxPrice = elements[33]; // 最高价
          topDataNw.minPrice = elements[34]; // 最低价

          topDataNw.num = elements[36]; // 成交量(手)
          topDataNw.totalAccount = elements[37]; // 成交额(万)
          topDataNw.turnoverRate = elements[38]; // 换手率
          topDataNw.priceToEarnings = elements[39]; // 市盈率

          topDataNw.swing = elements[43]; // 振幅
          topDataNw.stockMarketsFell = elements[44]; // 流通市值(亿)
          topDataNw.aggregatealueListedStock = elements[45]; // 总市值(亿)
          topDataNw.price2BookRatio = elements[46]; // 市净率
          topDataNw.hardenPrice = elements[47]; // 涨停价
          topDataNw.dropPrice = elements[48]; // 跌停价
          topDataNw.volumeRatio = elements[49]; // 量比
          topDataNw.appointment = elements[74]; // 尾差
          topDataNw.average = elements[51]; // 均价

          that.$nextTick(() => {
            that.topData = topDataNw;
          });
        },
      });
    },
    loadTimeShareData(code) {
      let that = this;
      $.get(
        "https://ifzq.gtimg.cn/appstock/app/minute/query?code=" + code +
          "&r=" +
          new Date().getTime(),
        function (res) {
          res = JSON.parse(res);

          let data = res.data[code].data.data;
          let priceArray = [],
            timeArray = [];
          data.forEach((element) => {
            element = element.split(" ");
            priceArray.push(element[1]);
            timeArray.push(element[0]);
          });

          that.loadTimeShare(timeArray, priceArray);
        }
      );
    },
    loadTimeShare(xData, yData) {
      var myChart = echarts.init(document.getElementById("timeshare"));

      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
        },
        grid: {
          left: "10%",
          right: "10%",
          bottom: "15%",
        },
        xAxis: {
          type: "category",
          data: xData,
          scale: true,
          boundaryGap: true,
          axisLine: { onZero: false },
          splitLine: { show: true },
          splitNumber: 20,
          min: "dataMin",
          max: "dataMax",
          axisLabel: {
            color: '#ffffff' 
      }
        },
        yAxis: {
          scale: true,
          splitArea: {
            show: true,
          },
          axisLabel: {
            color: '#ffffff' 
        }
        },
        dataZoom: [
          // {
          //   type: "inside",
          //   start: 90,
          //   end: 100,
          // },
          { type: "inside", show: true, realtime: true },
          {
            show: true,
            type: "slider",
            top: "90%",
            realtime: true,
          },
        ],
        series: [
          {
            type: "line",
            data: yData,
            smooth: true,
          },
        ],
      };
      myChart.setOption(option);
    },
    chartChange() {
      clearInterval(this.timerRef);
      this.loadTopData();
      this.loadData();
      this.timerRef = setInterval(() => {
        this.loadTopData();
        this.loadData();
      }, this.refreshInterval);
    },

    },
    mounted: function(){
    this.selectedShare = this.$route.query.symbol
    this.chartChange();
    },
    watch: {
    '$route.query.symbol': {
      immediate: true, 
      handler(newVal) {
        this.selectedShare = newVal;
      }
    }
  },
    created: function(){

    },
    destroyed: function(){
        clearInterval(this.timerRef);
        clearInterval(this.timerRefTop);
    
    }
    
}
</script>
<style scoped>
.kline_chart >>> .el-tabs__header.is-top,
.kline_chart >>> .el-tabs__content {
  background-color: black !important;
}

.kline_chart >>> .el-tabs__item {
  color: white !important;
}

.kline_chart >>> #tab-timeshare, .kline_chart >>> .el-tabs__active-bar.is-top{
  margin-left: 30px;
}

.kline_chart >>> .el-tabs__item.is-active {
  color:var(--baseColor) !important;
}

.kline_chart>>>.el-tabs__active-bar {
  background-color: var(--baseColor) !important;
}

.kline_chart >>>.el-tabs--top{
  background-color: black !important;
}

</style>


// WEBPACK FOOTER //
// src/components/newKline.vue